import React from 'react';

import Card from '@components/Card';
import Modal from '@shared/Modal';
import Spinner from '@shared/Spinner';
import Button from '@shared/Button';

import {
  ModalContainer,
  SummarySection,
  ErrorItem,
  ErrorRuleName,
  ErrorDetail,
  CloseButtonRow,
  DiffSummary,
  ValidationErrors,
  RawJsonView,
  getValidationErrors,
} from './RuleDiffShared';

export default function PreviewDiffModal({ response, isLoading, error, handleClose }) {
  // A validation failure can come back under `details` (strings) or `errors`
  // (objects), and a 4xx body is surfaced by useAPI's `errorData`. Only fall
  // back to the generic request-error message when there's no structured body.
  const validationErrors = getValidationErrors(response);
  const hasValidationErrors = !!validationErrors;
  const hasDiff = response && !hasValidationErrors && response.diff;
  const showRequestError = error && !hasValidationErrors && !hasDiff;

  let title = 'Rule Change Preview';
  if (hasValidationErrors) {
    title = 'Rule Change Preview — Validation Failed';
  }

  return (
    <Modal id='preview-diff-modal' open toggle={handleClose} closeOnClickOutside maxWidth={900}>
      <Card title={title} shadow>
        <ModalContainer>
          {isLoading && <Spinner center />}

          {showRequestError && (
            <SummarySection>
              <ErrorItem>
                <ErrorRuleName>Request Error</ErrorRuleName>
                <ErrorDetail>{error}</ErrorDetail>
              </ErrorItem>
            </SummarySection>
          )}

          {hasValidationErrors && (
            <ValidationErrors errors={validationErrors} />
          )}

          {hasDiff && (
            <>
              <DiffSummary
                diff={response.diff}
                emptyMessage='No rule changes detected. The uploaded rules match the current configuration.'
              />
              <RawJsonView src={response.diff} />
            </>
          )}

          <CloseButtonRow>
            <Button onClick={handleClose}>Close</Button>
          </CloseButtonRow>
        </ModalContainer>
      </Card>
    </Modal>
  );
}
